import type { Step } from 'react-joyride';

/**
 * The welcome tour: what each sidebar entry is for. Targets are the sidebar links (Sidebar.tsx);
 * a step whose target is missing (e.g. a page hidden by RBAC) is skipped.
 */
export function tourSteps(firstName: string | undefined): Step[] {
  return [
    {
      target: 'body',
      placement: 'center',
      title: firstName ? `Bienvenue, ${firstName}` : 'Bienvenue',
      content: (
        <>
          <p>
            Backstage, c'est le portail des devs Bobbee : tes environnements,
            tes PR, tes pipelines et la doc, au même endroit.
          </p>
          <p>On te montre l'essentiel en une minute ?</p>
        </>
      ),
    },
    {
      target: 'a[href="/my-work"]',
      title: 'Mon travail',
      content:
        'Tes tickets du sprint avec leurs PR, envs et pipelines. Le compteur indique ce qui attend une action de ta part.',
    },
    {
      target: 'a[href="/ephemeral-envs"]',
      title: 'Environnements éphémères',
      content: (
        <>
          <p>
            Déploie ta branche sur son propre environnement, avec sa base. Plus
            besoin d'attendre que la dev soit libre.
          </p>
          <p>
            Lie ton compte GitHub sur cette page pour retrouver tes PR et tes
            envs.
          </p>
        </>
      ),
    },
    {
      target: 'a[href="/catalog"]',
      title: 'Catalogue',
      content:
        "Composants, API et équipes. Pour savoir qui maintient quoi, et retrouver les logs d'un service.",
    },
    {
      target: 'a[href="/create"]',
      title: 'Create',
      content:
        "Génère une lambda ou un package standard. Backstage ouvre une PR sur ta branche, avec l'IaC et le CD déjà câblés.",
    },
    {
      target: 'a[href="/delivery"]',
      title: 'Livraison',
      content:
        'La version qui tourne en dev, staging et prod. Tape une clé Jira pour savoir où en est ton ticket.',
    },
    {
      target: 'a[href="/notifications"]',
      title: 'Notifications',
      content:
        'Env prêt, pipeline en échec, review demandée. Autorise les notifications du navigateur pour les recevoir même dans un autre onglet. Le bouton Paramètres de la page coupe un type de notification.',
    },
    {
      target: '.search-icon',
      title: 'Recherche',
      content:
        'Catalogue, docs et pages Confluence techniques, dans une seule barre.',
    },
    {
      target: 'body',
      placement: 'center',
      title: "C'est tout",
      content:
        'Le reste s’apprend en cliquant. Pour démarrer, la checklist « Premiers pas » t’attend en bas à droite.',
    },
  ];
}
